import styled from 'styled-components';

export const Mail = styled.div`
  box-sizing: border-box;
  height: 96px;
  border-radius: 20px;
  background-color: #ffffff;
  box-shadow: 0 0 50px 0 rgba(29, 66, 138, 0.15);
  font-family: Rubik;
  display: none;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 87px;
  padding: 24px 35px;
  > div {
    display: flex;
    flex-direction: column;
    strong {
      display: inline-block;
      font-weight: bold;
    }
    a {
      margin-top: 10px;
      display: inline-block;
      color: var(--blue);
    }
  }
  &:hover {
    box-shadow: 0 0 50px 0 rgba(29, 66, 138, 0.2);
    cursor: pointer;
  }
  @media (min-width: 992px) {
    display: flex;
    max-width: 456px;
    margin-top: 66px;
  }
`;

export const ContactStyled = styled.div`
  .container {
    padding: 0 20px;
    position: relative;
    margin-top: 180px;
    @media (min-width: 310px) {
      margin-top: 160px;
    }
    @media (min-width: 385px) {
      margin-top: 140px;
    }
    @media (min-width: 660px) {
      margin-top: 112px;
    }
    @media (min-width: 992px) {
      display: flex;
      margin-top: 160px;
    }
    > ${Mail} {
      display: flex;
      position: relative;
      bottom: 110px;
      width: 335px;
      margin: 0;
      @media (min-width: 768px) {
        width: 100%;
      }
      @media (min-width: 992px) {
        display: none;
      }
    }
  }
`;
export const LeftColumn = styled.div`
  @media (min-width: 992px) {
    max-width: 455px;
  }
`;
export const Title = styled.div`
  color: var(--black);
  font-family: Rubik;
  font-size: 48px;
  font-weight: bold;
  letter-spacing: -1px;
  line-height: 56px;
  @media (min-width: 992px) {
    font-size: 64px;
    line-height: 72px;
    margin-top: 38px;
  }
`;

export const Text = styled.div`
  color: var(--black);
  font-family: Rubik;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 24px;
  margin-top: 41px;
  strong {
    font-weight: bold;
  }
  @media (min-width: 992px) {
    margin-top: 58px;
  }
`;

export const TextFeatured = styled.div`
  color: var(--blue);
  font-family: Rubik;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 24px;
  margin-top: 36px;
  @media (min-width: 992px) {
    margin-top: 41px;
    font-size: 24px;
    line-height: 32px;
  }
`;

export const RightColumn = styled.div`
  position: relative;
  box-sizing: border-box;
  background: var(--dblue);
  width: 110vw;
  padding: 100px 20px;
  transform: translateX(-5%);
  clip-path: polygon(0 5%, 100% 0, 100% 90%, 0% 95%);
  margin-top: 73px;
  height: 900px;
  &.has-errors {
    height: 980px;
  }
  @media (min-width: 768px) {
    transform: translateX(-2.6%);
    width: 100vw;
  }
  @media (min-width: 1024px) {
    border-radius: 40px 0 0 40px;
    clip-path: none;
    margin: 0;
    height: 730px;
    max-height: 745px;
    padding: 64px 96px;
    padding-left: 20px;
    transform: translateX(25%);
    left: 50%;
    right: 50%;
    margin-left: -70%;
    margin-right: -50vw;
  }
  @media (min-width: 1200px) {
    padding-left: 64px;
  }
  @media (min-width: 1920px) {
    margin-left: -80%;
  }
`;

export const FormTitle = styled.h2`
  color: var(--white);
  font-family: Rubik;
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 24px;
`;

export const InputContainer = styled.div<{ hasError: boolean }>`
  display: flex;
  flex-direction: column;
  margin-top: 45px;
  label {
    display: flex;
    flex-direction: column;
    color: var(--gray);
    font-family: Rubik;
    font-size: 24px;
    letter-spacing: 0;
    line-height: 24px;
    transition: all 0.3s ease;
    cursor: pointer;
    input {
      font-family: Rubik;
      color: var(--white);
      background: none;
      outline: none;
      border: none;
      border-bottom: ${(props) =>
        props.hasError ? '1px solid var(--red)' : 'none'};
      resize: none;
      font-size: 24px;
      line-height: 24px;
      height: 34px;
      padding: 0px;
      transition: all 0.3s ease;
      border-radius: none;
    }
    textarea {
      font-family: Rubik;
      color: var(--white);
      background: none;
      outline: none;
      border: none;
      border-radius: none;
      border-bottom: ${(props) =>
        props.hasError ? '1px solid var(--red)' : 'none'};
      resize: none;
      font-size: 24px;
      line-height: 24px;
      height: 50px;
      padding: 0px;
      transition: all 0.3s ease;
    }
    &.active-input {
      font-size: 12px;
      transition: all 0.3s ease;
      input,
      textarea {
        border-bottom: 1px solid var(--white);
        height: 24px;
        transition: all 0.3s ease;
      }
      textarea {
        height: 50px;
      }
    }
    .error {
      display: ${(props) => (props.hasError ? 'flex' : 'none')};
      color: var(--red);
      font-family: Rubik;
      font-size: 12px;
      letter-spacing: 0;
      line-height: 24px;
    }
    @media (min-width: 992px) {
      max-width: 457px;
    }
  }

  &:first-of-type {
    margin-top: 34px;
  }
`;

export const ContactForm = styled.form<{
  hasDefaultError: boolean;
  hasSuccessMsg: boolean;
}>`
  width: 90%;
  .btn-container {
    margin-top: 25px;
    margin-bottom: 5px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    @media (min-width: 768px) {
      justify-content: flex-start;
      align-items: center;
      flex-direction: row;
    }
  }
  .msg-continer {
    .msg-error {
      display: ${(props) => (props.hasDefaultError ? 'block' : 'none')};
      color: var(--red);
      font-family: Rubik;
      font-size: 12px;
      line-height: 16px;
      margin-left: 24px;
    }
    .msg-success {
      display: ${(props) => (props.hasSuccessMsg ? 'block' : 'none')};
      color: var(--green);
      font-family: Rubik;
      font-size: 12px;
      line-height: 16px;
      margin-left: 24px;
    }
  }
  &.has-errors {
    ${InputContainer} {
      margin-top: 25px;
    }
  }
  @media (min-width: 992px) {
    max-width: 457px;
    width: 100%;
  }
`;

export const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 56px;
  width: 119px;
  .text {
    display: flex;
    color: var(--white);
    font-family: Rubik;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 16px;
  }
  .spin {
    display: none;
    border-radius: 50%;
    border: 2px solid var(--lblue);
    border-top: none;
    height: 10px;
    width: 10px;
    animation: spin 1.5s linear infinite;
  }
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  &:hover {
    .text {
      color: var(--blue);
    }
  }
`;

export const Btn = styled.button<{ isSubmitting: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 56px;
  width: 119px;
  border: 1px solid var(--white);
  border-radius: 32px;
  background: none;
  cursor: pointer;
  outline: none;
  pointer-events: ${(props) => (props.isSubmitting ? 'none' : 'initial')};
  margin: 32px 0 25px 0;
  > ${LoaderContainer} {
    .text {
      display: ${(props) => (props.isSubmitting ? 'none' : 'flex')};
    }
    .spin {
      display: ${(props) => (props.isSubmitting ? 'flex' : 'none')};
    }
  }
  &:hover {
    background: var(--white);
    color: var(--blue);
  }
  @media (min-width: 768px) {
    margin-left: 25px;
  }
`;
